import { ReactNode } from 'react';
import { GlobalStyles } from '@mui/material';
import {
  Header,
  LayoutAnimation,
  DynamicPreloaders,
  LayoutAnimationType,
} from 'core/common/ui/widgets';
import { ScreenAttributes } from 'core/flow/entities';
import { useFlowLayout } from './useFlowLayout';
import { BodyStyled, PageWrapperStyled } from './styled';

type FlowLayoutProps = {
  screenId: string;
  initialScreenId: string;
  screenAttributes: ScreenAttributes;
  nextScreenAttributes: ScreenAttributes | null;
  children: ReactNode;
};

export const FlowLayout = ({
  screenId,
  screenAttributes,
  nextScreenAttributes,
  initialScreenId,
  children,
}: FlowLayoutProps) => {
  const { background } = useFlowLayout(screenId);

  return (
    <>
      <DynamicPreloaders
        screenId={screenId}
        initialScreenId={initialScreenId}
        screenAttributes={screenAttributes}
        nextScreenAttributes={nextScreenAttributes}
      />
      <GlobalStyles
        styles={(theme) => ({
          body: {
            backgroundColor: theme.palette.background.mainBodyDesktop,
            [theme.breakpoints.up('mobile')]: {
              backgroundColor: theme.palette.background.mainBodyMobile,
            },
          },
        })}
      />

      {!background && <LayoutAnimation animationType={LayoutAnimationType.CLOUD} />}

      <BodyStyled background={background} data-testid={screenId}>
        <Header screenId={screenId} />
        <PageWrapperStyled component="main" maxWidth="container">
          {children}
        </PageWrapperStyled>
      </BodyStyled>
    </>
  );
};
